import React, { useContext, useEffect, useState } from 'react'
import { DContext } from '../../context/Datacontext' 
import AllList from './AllList'
import { fetchAllUsers } from '../services/fetchGetUser'

export default function UserManagement() {
  const { BeURL, showAlert, currentUser } = useContext(DContext)
  const [users, setUsers] = useState(null)

  useEffect(() => {
    const fetchUsers = async () => {
      await fetchAllUsers(BeURL, showAlert, setUsers, currentUser.company.companyId)
    }

    fetchUsers()
  }, [])

  return (
    <div className="min-h-[80vh] p-6">

      <h2 className="text-center text-2xl font-semibold text-primary-600 mb-3">
        Users Details
      </h2>

      <div>
        <AllList users={users}  />
      </div>
    </div>
  )
}
